import React from "react";
import useTranslation from "next-translate/useTranslation";
import Slider from "react-slick";
import Image from "next/image";

import { DATA_MOCKUP } from "./mockup";

const Member = () => {
  const { t } = useTranslation("about-us");

  const settings = {
    autoplay: false,
    autoplaySpeed: 4500,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991.98,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576.01,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div className="member">
      <div className="member__background" />
      <div className="member__background2" />

      <div className="member__content">
        <div className="member__content__left">
          <h2>{t("member.title")}</h2>
          <div className="member__content__left__line" />
          <p>{t("member.desc")}</p>
        </div>

        <div className="member__content__right">
          <Slider {...settings}>
            {DATA_MOCKUP?.map((item) => (
              <React.Fragment key={item?.key}>
                <div className="member__content__right__card">
                  <div className="image">
                    <Image src={item?.image} alt="avatar" layout="fill" />
                  </div>
                  <span className="name">{item?.name || ""}</span>
                  <p className="position">{item?.position || ""}</p>
                  <p className="quote">{`"${item?.quote || ""}"`}</p>
                </div>
              </React.Fragment>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Member;
